// extracted by mini-css-extract-plugin
export var divider = "_qn-0";
export var systemMessage = "_qn-1";